<!-- 乘机人 列表 -->
<template>
  <div class="traver">
    <van-cell
      :title="title"
      :border="false"
    >
      <slot
        name="title"
        slot="title"
      />
      <span
        v-show="addButton"
        class="addCxr main-color"
        @click="$refs.empList.toggle({ index: 1 })"
      >
        + {{ $t('B001', '添加') }}
      </span>
      <!--      <span-->
      <!--        v-show="addButton"-->
      <!--        class="addCxr main-color"-->
      <!--        @click="$refs.addChildren.toggle()"-->
      <!--        style="margin-left: 5px;"-->
      <!--      >-->
      <!--        + 加儿童-->
      <!--      </span>-->
    </van-cell>

    <div
      v-for="(psg, index) in travelerList"
      :key="index"
      class="traveler-item van-hairline--top"
    >
      <!-- 儿童 -->
      <!--      <van-row-->
      <!--        v-if="psg.psgType == 2"-->
      <!--        type="flex"-->
      <!--        align="center"-->
      <!--      >-->
      <!--        <van-col-->
      <!--          class="delete"-->
      <!--          @click="deletePsg(index)"-->
      <!--        >-->
      <!--          <ld-icon-->
      <!--            class="red"-->
      <!--            type="iconjianshao"-->
      <!--          />-->
      <!--        </van-col>-->

      <!--        <van-col class="info">-->
      <!--          <div class="font16 font-md">-->
      <!--            {{ psg.empName }}-->
      <!--            <van-tag plain>-->
      <!--              {{ psg.psgType | passengerType }}-->
      <!--            </van-tag>-->
      <!--          </div>-->
      <!--          <div class="font12 gray mt5">-->
      <!--            使用{{ psg.empName }}的证件取票{{psg.psgType}}-->
      <!--          </div>-->
      <!--        </van-col>-->
      <!--      </van-row>-->

      <!-- 成人 -->
      <van-row
        type="flex"
        align="center"
      >
        <van-col
          class="delete"
          @click="deletePsg(index, psg)"
        >
          <ld-icon
            class="red"
            type="iconjianshao"
          />
        </van-col>

        <van-col
          class="info"
          @click="editPsg(psg)"
        >
          <div class="font16 font-md">
            {{ psg | getName }}
            <van-tag plain>
              {{ psg.psgType | passengerType }}
            </van-tag>
          </div>
          <div class="font12 gray mt5">
            <span v-if="psg.cardName">
              {{ psg.cardName }}
            </span>
            <span v-else>
              {{ psg.cardType | cardType }}
            </span>
            <span v-if="!psg.cardType || psg.cardType == '1'">
              {{ psg.idNo || psg.cardNo }}
            </span>
            <span v-else-if="psg.cardType == 'B'">
              {{ psg.cardNo }}
            </span>
            <span v-else-if="psg.cardType">
              {{ psg.cardNo }}
            </span>
            <div>{{ $t('F008', '手机号') }}：{{ psg.phoneNumber }}</div>
          </div>
        </van-col>

        <van-col
          class="edit"
          @click="editPsg(psg)"
        >
          <ld-icon
            class="gray"
            type="iconright"
          />
        </van-col>
      </van-row>
    </div>

    <emp-list
      ref="empList"
      :cplx="cplx"
      :person-list="personList"
      @selected="empCallBack"
      :element="element"
      :radio="radio"
      @radioSelected="radioSelected"
    />

    <ld-edit-psg
      ref="ldEditPsg"
      :psg-info="psgInfo"
      @selected="getEditPsg"
      :element="element"
    />

    <add-children
      ref="addChildren"
      :traveler-list="travelerList"
      @selected="addChildren"
    />
  </div>
</template>

<script>
import {Tag, Cell} from 'vant'
import {mapGetters} from 'vuex'
import {localget} from 'Utils/storage.js'

import ldButton from 'Common/ldButton'
import empList from 'Components/ldEmpList/index.vue'
import ldEditPsg from 'Components/ldEditPsg/tr_ver.vue'
import addChildren from './addChildren.vue'

export const CheckCodeDesc = {
  '-3': '<span class="red">核验未通过，请通知乘车人尽快报验</span>',
  '-2': '<span class="red">您的身份信息涉嫌被他人冒用，请到就近办理客运售票业务的铁路车站完成身份核验</span>',
  '-1': '<span class="red">核验未通过，请通知乘车人尽快完成核验</span>',
  '0': '<span class="red">手机号待核验，请前往核验</span>',
  '2': '<span class="red">手机号待核验，请前往核验</span>',
  '1': '<span class="green">联系信息已核验通过</span>',
  '3': '<span class="red">核验未通过，请补全联系信息</span>',
  'loading': '核验中，乘车人完成核验后，刷新状态查看'
}

export default {
  name: 'Traver',
  components: {
    ldButton,
    empList,
    ldEditPsg,
    addChildren,
    [Cell.name]: Cell,
    [Tag.name]: Tag
  },
  props: {
    travelerList: {//需要展示的出行人
      type: [Array, Object],
      required: true,
      default: function () {
        return []
      }
    },
    personList: {//出差申请单中乘机人集合
      type: [Array, Object],
      default: function () {
        return []
      }
    },
    title: {
      type: String,
      default: '乘机人'
    },
    disabled: {
      //禁止滑动
      type: Boolean,
      default: false
    },
    addButton: {
      //显示增加 按钮
      type: Boolean,
      default: true
    },
    cplx: {
      //产品类型
      type: String,
      default: '10904'
    },
    storeName: {
      type: String,
      default: 'tk/travelerList'
    },
    element: {
      type: String,
      default: ''
    },
    radio: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      psgInfo: {},
      CheckCodeDesc,
      cplxObj: {
        '10901': 'tk',
        '10902': 'tkInt',
        '10903': 'ht',
        '10904': 'tr'
      }
    }
  },
  created() {
  },
  methods: {
    radioSelected(info) {
      this.list = [info]
      this.$store.commit(this.storeName, [info])
    },
    empCallBack(info) {
      this.$store.commit(`${this.cplxObj[this.cplx]}/travelerList`, info)
      this.$emit('match-clzc')
    },
    getEditPsg(info) {
      this.travelerList.forEach(item => {
        // 附属人
        if (item.clkFlag == 1) {
          if (info.clkFlag == 1) {
            if (item.contactsId && info.contactsId) {
              item = info
            }
          }

          // 常旅客
        } else if (item.clkFlag == 0) {
          if (info.clkFlag == 0) {
            if (item.contactsId && info.contactsId) {
              item = info
            }
          }

          // 员工
        } else if (item.clkFlag == 2 || !item.clkFlag) {
          if (info.clkFlag == 2 || !item.clkFlag) {
            if (item.empId && info.empId) {
              item = info
            }
          }
        }
      })
      this.$forceUpdate() // 强制更新
    },
    editPsg(psg) {
      console.log('psgpsg{}', psg)
      // const userInfo = localget('userInfo') || {};
      // if (userInfo && userInfo.vipCorp && userInfo.vipCorp.bookStyle && userInfo.empInfo) {
      //   // 申请单模式用户端统一不能修改人员信息
      //   if (userInfo.vipCorp.bookStyle === 2) {
      //     this.$dialog({message: '不能修改人员信息'});
      //     return;
      //   }
      //   if (userInfo.vipCorp.bookStyle === 1 && userInfo.empInfo.xgygxx === 0) {
      //     this.$dialog({message: '不能修改人员信息'});
      //     return;
      //   }
      // }

      this.psgInfo = psg
      this.$refs.ldEditPsg.toggle()
    },
    addChildren(psg, i) {
      this.$refs.addChildren.toggle()
      let len = !this.travelerList ? 0 : this.travelerList.length
      if (len == 5) {
        this.$dialog.alert({message: '火车票一次预订，最多订5人！'})
        return false
      } else {
        let child = {
          psgType: '2', //  乘车人类型1、成人；2儿童 ,
          ticketType: '2', //  车票类型 1成人票 2儿童票 3学生票 4残军票
          empName: this.$options.filters.getName(psg)
        }
        this.travelerList.splice(i + 1, 0, child)
        this.$store.commit(`${this.cplxObj[this.cplx]}/travelerList`, this.travelerList)
      }
    },
    // 删除乘车人
    deletePsg(index, curPsg) {
      this.travelerList.splice(index, 1)
      /**
       * 当一个成人添加了儿童，删除成人后，关联的儿童也要自动删除
       */
      if (curPsg && (curPsg.psgType == 1 || !curPsg.psgType)) {
        this.travelerList = this.travelerList.filter((psg) => {
          return !(this.$options.filters.getName(curPsg) === psg.empName && psg.psgType === '2')
        })
      }

      this.$store.commit(`${this.cplxObj[this.cplx]}/travelerList`, this.travelerList)
      this.$emit('selected', this.travelerList)
      this.$emit('match-clzc')
    },
    toggle() {
      this.isShow = !this.isShow
    }
  },
  computed: {
    ...mapGetters({
      trSearchInfo: 'tr/trSearchInfo',
    })
  },
  filters: {
    passengerType(val) {

      if (val == 1 || val == undefined) {
        console.log("passengerType val {},成人",val)
        return '成人'
      } else {
        console.log("passengerType val {},儿童",val)
        return '儿童'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.traver {
  .addCxr {
    display: inline-block;
    padding: 0px 10px;
    border-radius: 15px;
    text-align: center;
    font-size: @font-size-14;
    border-width: 1px;
    border-style: solid;
  }

  .traveler-item {
    width: 100%;
    padding: 10px 0 10px 15px;
    background-color: @color-background-white;

    .delete {
      width: 35px;
    }

    .info {
      width: calc(100% - 86px);
    }

    .edit {
      width: 45px;
      margin-left: 5px;
    }
  }

  .van-tag {
    vertical-align: text-bottom
  }
}
</style>
